import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/noimg.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-65306bd9")

_pushScopeId("data-v-65306bd9")
const _hoisted_1 = { class: "img-cover" }
const _hoisted_2 = {
  key: 0,
  class: "left-img"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "r-text" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("支持格式：")
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "jpg、jpeg、png", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 最佳尺寸：")
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 图片大小：")
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "2M以内", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("上传")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_vue_cropper = _resolveComponent("vue-cropper")
  const _component_a_modal = _resolveComponent("a-modal")
  const _component_a_icon = _resolveComponent("a-icon")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_upload = _resolveComponent("a-upload")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_a_modal, {
      visible: _ctx.modalVisible,
      title: _ctx.title,
      cancelText: "取消",
      cancelType: "link",
      okText: "确定",
      onCancel: _ctx.onCancel,
      keyboard: false,
      onOk: _ctx.onOk,
      loading: _ctx.loading,
      maskClosable: false
    }, {
      default: _withId(() => [
        (`${_ctx.aspectRatio}` !== "NaN")
          ? (_openBlock(), _createBlock(_component_vue_cropper, {
              key: 0,
              ref: "cropper",
              src: _ctx.imgSrc,
              aspectRatio: _ctx.aspectRatio
            }, null, 8, ["src", "aspectRatio"]))
          : (_openBlock(), _createBlock(_component_vue_cropper, {
              key: 1,
              ref: "cropper",
              src: _ctx.imgSrc
            }, null, 8, ["src"]))
      ]),
      _: 1
    }, 8, ["visible", "title", "onCancel", "onOk", "loading"]),
    (!_ctx.path && !_ctx.urlsrc)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3
        ]))
      : (_openBlock(), _createBlock("img", {
          key: 1,
          class: "left-img",
          src: _ctx.path || _ctx.urlsrc
        }, null, 8, ["src"])),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _createVNode("span", null, _toDisplayString(_ctx.text), 1),
        _hoisted_10,
        _hoisted_11,
        _hoisted_12
      ]),
      _createVNode(_component_a_upload, {
        accept: ".jpg, .jpeg, .png",
        showUploadList: false,
        disabled: _ctx.disabled,
        beforeUpload: _ctx.beforeUpload
      }, {
        default: _withId(() => [
          _createVNode(_component_a_button, { type: "dashed" }, {
            default: _withId(() => [
              _createVNode(_component_a_icon, { type: "upload" }),
              _hoisted_13
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["disabled", "beforeUpload"])
    ])
  ]))
})